module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-case"
  }, [_c('img', {
    staticClass: "top-img",
    attrs: {
      "src": require("assets/case/03/img1.png")
    }
  }), _vm._m(0), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.scrollTop),
      expression: "scrollTop"
    }],
    staticClass: "scroll-top-btn",
    attrs: {
      "src": require("assets/goTop.png")
    },
    on: {
      "click": _vm.backtop
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "case-num"
  }, [_vm._v("Vol.03")]), _c('div', {
    staticClass: "case-title"
  }, [_vm._v("上海175㎡暗黑系霸道总裁风，花100万装修只为这种feel")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("有人喜欢把家装成北欧风，有人则喜欢“暗戳戳”的低调范，在属于你的家里，怎样都是合理的。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("今天窝仔要给大家介绍的客户陈小姐的家，她的家，绝非用“个性”二字可以形容。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/03/img2.png")
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("「背景信息」")]), _c('div', {
    staticClass: "line1"
  }, [_c('span', [_vm._v("关于屋主")]), _vm._v("陈小姐与先生也是家居领域的从商者，为了方便家里两个孩子上学，投入重金在上海黄浦区核心地段购置了这套学区房。由于职业背景缘故，两人对家居品位都有着非常高的审美与追求。")]), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("「房子的基本信息」")]), _c('div', {
    staticClass: "line1"
  }, [_c('span', [_vm._v("坐标：上海黄浦")]), _vm._v(" "), _c('span', [_vm._v("面积：175㎡")]), _vm._v(" "), _c('span', [_vm._v("户型：三室一厅")])]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/03/img3.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("房子的原始状态是毛坯房，男主人偏爱暗黑系的霸道总裁风，简约大气又不乏精致感，为了呈现出满意的效果，装修前后耗时一年之久。")]), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("玄关：简约摩登的气质")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("进门入玄关，以通透的柜体遮挡区隔，视线可及客餐厅，有种犹抱琵琶半遮面的效果。男主人偏爱冷色调，大面积的黑白与玄关天花处暗藏的灯带，将气质定格在简约摩登。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/03/img4.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("右手边是厨房，推拉门节省了空间。平时小孩在客厅玩，做饭的大人也能随时掌握他们的动向。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/03/img2.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("墙面采用大面积深棕色木饰面，虽然被家里老人吐槽说太暗了，但却为整个空间奠定了沉稳大气的基调。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/03/img6.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("隔断柜架的底部，也有隐藏灯带，让整个空间显得轻盈通透。上下灯带交相呼应，打造出自然柔和的照明效果。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/03/img7.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("地面是大面积石砖，纹路清晰自然，水墨的意蕴从地面延伸到墙上，中和木饰面的暗色调，让玄关空间更加灵活有机。")]), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("客餐厅：做足收纳，实用美观")]), _c('div', {
    staticClass: "line1"
  }, [_c('span', [_vm._v("餐厅，处处体现细心")]), _vm._v(" "), _c('span', [_vm._v("经过玄关，右转来到餐厅。")])]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/03/img8.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("这个空间的墙面依然是深色为主，吊顶和地面则是白色。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/03/img9.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("餐厅的主角是一整套懂窝餐桌椅。蒙塔娜餐桌 有着北美橡木的原始粗犷，经擦色涂装工艺处理，呈现出独特的做旧风味，而桌腿则为实心铸铁打造，如枝干般遒劲有力。这种硬朗的工业风，与整个空间的气质相得益彰。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/03/img10.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("一张蒙塔娜长凳跟餐桌配套，独特的燕尾榫成为富有巧思的点缀，两个小孩排排坐着吃饭，亲密无间又讨喜，是父辈想带给他们的快乐。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/03/img11.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("同时搭配四张达希尔餐椅，造型纤细优雅，颜色材质和餐桌相匹配。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/03/img12.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("餐厅左侧墙面有一个内嵌的置物台，可以放水壶、茶叶等物品，吃饭时还可以暂时放置碗盘，整个区域都保持着美而不乱，实用又好看。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/03/img7.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("餐厅区收纳功能必不可少，餐桌后面是一整面储物柜，深色玻璃起到遮掩效果，减少了杂乱感。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/03/img10.png")
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("客厅，提升温馨感")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("紧邻餐厅的就是客厅，相对其他区域显得很明亮。设计很简洁，以白、灰为主。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/03/img15.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("这里是一家人活动的主要空间，增加了很多温馨的元素。比如沙发墙面采用浅灰色皮质软包，相比石材墙面，多了几分柔和。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/03/img16.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("电视墙依然延续了大面积石材，与地面呼应，简洁耐看。窗外透进来的自然光，经墙面反射，让客厅区因此显得明亮通透。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/03/img17.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("一张萨斯基亚地毯，为客厅的温馨感加分，低调的外观没有喧宾夺主，厚实柔软的触感，让这里成为小朋友们玩耍的最佳领地。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/03/img18.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("沙发是现代风格的懂窝热卖款弗雷德里克窄扶手四人沙发，造型简洁大方，宽大舒适。定制的棉麻面料，既温馨，又结实耐用。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/03/img19.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("房子是家的容器，承载了居住者的个性主张、兴趣与爱。这种暗黑系也是你喜欢的feel吗？欢迎留言告诉我们。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("看了这么多客户家，窝仔越发觉得，不管住在怎样的房子里，每个人都应该把对生活的热情投入到每一天，再平凡的日子，也能迸发出不平凡的精彩。")]), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("装修巧思")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("•  收纳柜门选用深色玻璃，弱化杂乱感，也方便找东西")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("•  利用边角位置巧妙设计置物台，方便日常随手置物")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("•  把卫生间的门“藏”进墙面，既美观又隐蔽")]), _c('div', {
    staticClass: "cont-title1"
  }, [_vm._v(" Q&A")]), _c('div', {
    staticClass: "line2"
  }, [_c('span', [_vm._v("Q：为什么选择懂窝的家具？")]), _vm._v("装完硬装后逛家具，碰巧看到懂窝的风格跟我家很搭，价格又合理，就选择懂窝了。")]), _c('div', {
    staticClass: "line2"
  }, [_c('span', [_vm._v("Q：在软装搭配方面有什么心得？")]), _vm._v("都是让懂窝的软装搭配师帮我搭配的，大件的床、沙发、地毯，小件的抱枕、茶几、灯，搭配在一起的效果都不错。")]), _c('div', {
    staticClass: "line2"
  }, [_c('span', [_vm._v("Q：花了多少钱装修？")]), _vm._v("从硬装到软装，前前后后总共花了一百万左右吧。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5003cf6d"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/case3.vue
// module id = 443
// module chunks = 0